export default __webpack_public_path__ + "static/media/four.36d8581a.jpg";